import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['results']

  search() {
    const searchQuery = event.currentTarget.value

    if (searchQuery) {
      this.resultsTarget.src = `${event.currentTarget.dataset.updateUrl}?search=${searchQuery}`
    } else {
      this.resultsTarget.src = event.currentTarget.dataset.updateUrl
    }
  }
}
